<template>
  <div class="inspecRecordDetalis">
    <div class="headLine">
      <img src="./leftAngle.png" alt="返回首页" @click="backIndex" />
      详情
    </div>
    <el-form
      class="warningDetail"
      ref="dataForm"
      :model="dataForm"
      label-width="115px"
    >
      <el-form-item label="日期:" prop="date">
        <el-input v-model="dataForm.date" disabled />
      </el-form-item>
      <el-form-item label="时间:" prop="hour">
        <el-input v-model="dataForm.hour" disabled />
      </el-form-item>
      <el-form-item label="巡查人员:" prop="userlist">
        <el-input v-model="dataForm.userlist" disabled />
      </el-form-item>
      <el-form-item label="天气:" prop="weather">
        <el-input v-model="dataForm.weather" disabled />
      </el-form-item>
      <el-form-item label="提供管网信息路段:">
        <el-checkbox v-model="dataForm.xiShui" true-label="√" false-label="*" disabled
        >西水路</el-checkbox
        >
        <el-checkbox v-model="dataForm.xianDao" true-label="√" false-label="*" disabled
        >X523县道</el-checkbox
        >
        <el-checkbox v-model="dataForm.jinXiang" true-label="√" false-label="*" disabled
        >进港路</el-checkbox
        >
        <el-checkbox v-model="dataForm.baiJin" true-label="√" false-label="*" disabled
        >白金大道</el-checkbox
        >
        <el-checkbox v-model="dataForm.tangJiu" true-label="√" false-label="*" disabled
        >塘九路</el-checkbox
        >
        <el-checkbox v-model="dataForm.guiDan" true-label="√" false-label="*" disabled
        >桂丹路</el-checkbox
        >
        <el-checkbox v-model="dataForm.qiaoJin" true-label="√" false-label="*" disabled
        >樵金路</el-checkbox
        >
        <el-checkbox v-model="dataForm.nanZhuang" true-label="√" false-label="*" disabled
        >南庄紫南</el-checkbox
        >
      </el-form-item>
      <h5 style="margin: 15px 0;">巡查情况新问题</h5>
      <el-table
        :data="dataForm.newProblemDtos"
        border
        stripe
        style="width: 100%;"
      >
        <el-table-column
          prop="content"
          header-align="center"
          align="center"
          label="内容"
        />
      </el-table>
      <h5 style="margin: 15px 0;">问题跟踪</h5>
      <el-table
        :data="dataForm.trackProblemDtos"
        border
        stripe
        style="width: 100%;"
      >
        <el-table-column
          prop="problemContent"
          header-align="center"
          align="center"
          label="问题内容"
        />
        <el-table-column
          prop="trackContent"
          header-align="center"
          align="center"
          label="追踪情况"
        />
        <el-table-column
          header-align="center"
          align="center"
          label="图片"
        >
          <template slot-scope="scope">
            <el-image
              :src="item.filePath"
              v-for="item in scope.row.imgList"
              :key="`pic`+item.id"
              :preview-src-list="scope.row.imgList"
              fit="cover"
              class="picImg"
            />
          </template>
        </el-table-column>
      </el-table>
      <h5 style="margin: 15px 0;">问题解决</h5>
      <el-table
        :data="dataForm.solveProblemDtos"
        border
        stripe
        style="width: 100%;margin-bottom: 15px;"
      >
        <el-table-column
          prop="problemContent"
          header-align="center"
          align="center"
          label="问题内容"
        />
        <el-table-column
          prop="solveContent"
          header-align="center"
          align="center"
          label="解决情况"
        />
        <el-table-column
          header-align="center"
          align="center"
          label="图片"
        >
          <template slot-scope="scope">
            <el-image
              :src="item.filePath"
              v-for="item in scope.row.imgList"
              :key="`pic`+item.id"
              :preview-src-list="scope.row.imgList"
              fit="cover"
              class="picImg"
            />
          </template>
        </el-table-column>
      </el-table>
      <el-form-item label="管线资料发放登记:" prop="pipelineData">
        <el-input v-model="dataForm.pipelineData" type="textarea" rows="8" disabled />
      </el-form-item>
      <el-form-item label="备注:" prop="remarks">
        <el-input v-model="dataForm.remarks" type="textarea" rows="8" disabled />
      </el-form-item>
    </el-form>
    <div class="subBtn" v-if="(userId === 1 && !this.dataForm.monitorCheckTime) || (userId === 2 && !this.dataForm.managerCheckTime)">
      <el-button @click="makeSureComfirm" type="success">确认</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      id: '',
      userId: parseInt(sessionStorage.getItem("userId")),
      dataForm: {
        baiJin: null,
        confirmTime: null,
        date: null,
        guiDan: null,
        hour: null,
        id: null,
        jinXiang: null,
        managerCheckTime: null,
        monitorCheckTime: null,
        nanZhuang: null,
        newProblemDtos: [],
        pipelineData: null,
        qiaoJin: null,
        remarks: null,
        sendTime: null,
        solveProblemDtos: [],
        tangJiu: null,
        trackProblemDtos: [],
        userlist: [],
        weather: null,
        xiShui: null,
        xianDao: null
      },
    }
  },
  methods: {
    // 返回首页
    backIndex() {
      this.$router.replace({ name: "inspectionList" })
    },
    getDetailsById () {
      // 先拿id
      this.id = this.$route.query.id
      // 然后拿工单详情
      this.$http.httpGet(`/app/appTbInspectionRecord/info/`+ this.id).then(res => {
        if (res.code === 0 && res.msg === 'success') {
          this.dataForm = res.vo;
          if (this.dataForm.trackProblemDtos && this.dataForm.trackProblemDtos.length > 0) {
            this.dataForm.trackProblemDtos.forEach(i => {
              i.imgList = [];
              if (i.fileList.length > 0) {
                i.fileList.forEach(s => {
                  i.imgList.push(s.filePath)
                })
              }
            })
          }
          if (this.dataForm.solveProblemDtos && this.dataForm.solveProblemDtos.length > 0) {
            this.dataForm.solveProblemDtos.forEach(q => {
              q.imgList = [];
              if (q.fileList.length > 0) {
                q.fileList.forEach(f => {
                  q.imgList.push(f.filePath)
                })
              }
            })
          }
        } else {
          // this.$message.error(res.msg)
          this.$alert('获取管网巡查情况信息出错, 原因:' + res.msg, '提示', {
            confirmButtonText: '确定',
            callback: () => {
              window.history.back(-1)
            }
          });
        }
      })
    },
    makeSureComfirm() {
      this.$http.httpPost('/app/appTbInspectionRecord/confirm', {}, {
        "inspectionRecordId": this.dataForm.id
      }).then(res => {
        if (res.msg === 'success' && res.code === 0) {
          this.$message.success('确认成功!')
          this.$router.replace({ name: "inspectionList" })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
  },
  created () {
    this.getDetailsById()
  }
}
</script>

<style lang="scss">
@use '@/assets/style/global.scss';
.inspecRecordDetalis {
  background-color: #fff;
  padding: 60px 0 0;
  .headLine {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    background-color: #409eff;
    height: 50px;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
    font-weight: 600;
    text-align: center;
    line-height: 50px;
    z-index: 99;
    border-bottom: 1px #efefef solid;
    img {
      height: 30px;
      margin: 10px 0;
      padding: 0 10px;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .warningDetail {
    position: relative;
    padding: 0 15px 70px;
    .el-form-item {
      margin: 0 0 15px;
      position: relative;
      .el-form-item__label {
        font-size: 12px;
        width: 100px;
        float: left;
      }
      .el-form-item__content {
        width: calc(100% - 115px);
        .el-input, .el-select {
          width: 100%;
        }
      }
    }
    .tipsValue {
      font-size: 13px;
      line-height: 1.4;
      margin: 0 0 8px;
      font-weight: 600;
    }
    .picImg {
      width: 100px;
    }
  }
  .subBtn {
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    z-index: 9999;
    background-color: #fff;
    border-top: 1px #efefef solid;
    padding: 10px 0;
    .el-button {
      width: 100%;
    }
  }
}

</style>
